import { render, staticRenderFns } from "./CenterBox.vue?vue&type=template&id=4fa8e61a&scoped=true"
import script from "./CenterBox.vue?vue&type=script&lang=js"
export * from "./CenterBox.vue?vue&type=script&lang=js"
import style0 from "./CenterBox.vue?vue&type=style&index=0&id=4fa8e61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8e61a",
  null
  
)

export default component.exports